import { ILogger } from '@cian/logger';

import { TMessage } from '../../types/postMessage';
import { isInIframe } from '../isInIframe';

interface IPostFrameMessageParams {
  message: TMessage;
  targetOrigin: string;
  logger: ILogger;
}

export function postFrameMessage({ message, targetOrigin, logger }: IPostFrameMessageParams) {
  const isIframe = isInIframe();

  if (!isIframe || !window.parent) {
    logger.warning('Попытка вызвать postMessage не в iframe', {
      domain: 'postFrameMessage',
    });

    return;
  }

  try {
    window.parent.postMessage(message, targetOrigin);
  } catch (error) {
    logger.warning(error, { domain: 'postFrameMessage' });
  }
}
